(function() {
  'use strict';

  let zoomSwiper = null;

  function initProductGallery() {
    const galleries = document.querySelectorAll('.ec-product-gallery');
    
    galleries.forEach(gallery => {
      const thumbnails = gallery.querySelectorAll('.ec-product-gallery__thumbnail');
      const mainItems = gallery.querySelectorAll('.ec-product-gallery__main-item');
      const zoomButtons = gallery.querySelectorAll('.js-ec-zoom-trigger');

      const handleMobileZoom = (btn, e) => {
        if (window.innerWidth < 750) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          }

          const fullMediaId = btn.dataset.mediaId;
          const mobileModal = document.getElementById('ECImageZoomModal');

          if (mobileModal) {
            mobileModal.style.display = 'block';
            mobileModal.classList.add('active');
            document.body.classList.add('ec-zoom-open');
            document.documentElement.style.overflow = 'hidden';

            const swiperEl = mobileModal.querySelector('.js-ec-zoom-swiper');
            
            // Initialize or update Swiper
            if (!zoomSwiper && typeof Swiper !== 'undefined') {
              console.log('Initializing Zoom Swiper');
              zoomSwiper = new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                observer: true,
                observeParents: true,
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                }
              });
            }

            if (zoomSwiper) {
              const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
              const targetIndex = slides.findIndex(s => s.dataset.mediaId === fullMediaId);
              
              console.log('Sliding to index:', targetIndex, 'for media:', fullMediaId);
              
              setTimeout(() => {
                zoomSwiper.update();
                if (targetIndex !== -1) {
                  zoomSwiper.slideTo(targetIndex, 0);
                }
              }, 50);
            }
            
            const closeModal = () => {
              mobileModal.classList.remove('active');
              mobileModal.style.display = '';
              document.body.classList.remove('ec-zoom-open');
              document.documentElement.style.overflow = '';
            };
            
            const closeBtn = mobileModal.querySelector('.ec-image-zoom-modal__close');
            const overlay = mobileModal.querySelector('.ec-image-zoom-modal__overlay');
            if (closeBtn) closeBtn.onclick = closeModal;
            if (overlay) overlay.onclick = closeModal;
          }
          return true;
        }
        return false;
      };

      // Use Event Delegation on the gallery to catch clicks during Capture Phase
      gallery.addEventListener('click', function(e) {
        if (window.innerWidth < 750) {
          // Check if click is on zoom button or image
          const zoomBtn = e.target.closest('.js-ec-zoom-trigger');
          const mainImg = e.target.closest('.ec-product-gallery__main-item img');

          if (zoomBtn) {
            handleMobileZoom(zoomBtn, e);
          } else if (mainImg) {
            const btn = mainImg.closest('.ec-product-gallery__main-item').querySelector('.js-ec-zoom-trigger');
            if (btn) handleMobileZoom(btn, e);
          }
        }
      }, true); // CAPTURE PHASE to intercept before magnify.js

      zoomButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
          if (window.innerWidth >= 750) {
            // Desktop behavior
            const fullMediaId = this.dataset.mediaId;
            const mainItem = gallery.querySelector(`#ECMedia-${fullMediaId}`);
            if (!mainItem) return;

            const sectionId = gallery.closest('[id^="MainProduct-"]')?.id.replace('MainProduct-', '') || '';
            const modal = document.getElementById(`ProductModal-${sectionId}`);
            const mediaIdOnly = fullMediaId.replace(`${sectionId}-`, '');

            if (modal && typeof modal.show === 'function') {
              const tempOpener = document.createElement('button');
              tempOpener.setAttribute('data-media-id', mediaIdOnly);
              modal.show(tempOpener);
            }
          }
        });
      });
      
      thumbnails.forEach(thumbnail => {
        thumbnail.onclick = function() {
          const mediaId = this.dataset.target;
          const targetMainItem = gallery.querySelector(`#ECMedia-${mediaId}`);
          if (!targetMainItem) return;
          
          thumbnails.forEach(thumb => {
            thumb.classList.remove('ec-product-gallery__thumbnail--active');
            thumb.setAttribute('aria-current', 'false');
          });
          mainItems.forEach(item => item.classList.remove('ec-product-gallery__main-item--active'));
          
          this.classList.add('ec-product-gallery__thumbnail--active');
          this.setAttribute('aria-current', 'true');
          targetMainItem.classList.add('ec-product-gallery__main-item--active');
        };
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
  document.addEventListener('shopify:section:load', initProductGallery);
})();
